import Header from './Header';
import Spinner from './Spinner';
import { useEffect, useState } from '@wordpress/element';
import DeliveryTimeItem from './DeliveryTimeItem';
import { VendorDeliveryTimeData, VendorInfo } from '../types/DeliveryTIme';
import { __, sprintf } from '@wordpress/i18n';
import Error from './Error';

// @ts-ignore
const settings = window.wc.wcSettings.getSetting( 'dokan_delivery_time_data' );

const DeliveryTime = ( props ) => {
    const [ loading, setLoading ] = useState( false );
    const [ deliveryTime, setDeliveryTime ] = useState( {} );
    const dateTime = settings?.dateTime ?? '';

    // Collect delivery infos & admin delivery days.
    const infos: Record< string, VendorInfo > = settings?.vendorInfo;

    const defaultData = {
        delivery_date: '',
        delivery_time_slot: '',
        locationSlots: [],
        selected_delivery_type: 'pickup',
        store_name: '',
        store_pickup_location: '',
        timeSlots: [],
        vendor_id: '0',
    };

    const deliveryTimeHandler = ( vendorId, data ) => {
        const values = {
            ...deliveryTime,
            [ vendorId ]: data,
        };

        setDeliveryTime( values );

        props.onChange( {
            data: values,
            error: validateDeliveryTime( values ),
        } );
    };

    const validateDeliveryTime = (
        values: Record< string, VendorDeliveryTimeData >
    ) => {
        let error = '';

        Object.values( values ).forEach( ( data ) => {
            if ( ! error && ! data.vendor_id ) {
                error = __( 'Vendor not found.', 'dokan' );
            } else if ( ! error && ! data.store_name ) {
                error = __( 'Vendor not found.', 'dokan' );
            } else if ( ! error && ! data.selected_delivery_type ) {
                error = __( 'Select a delivery type.', 'dokan' );
            } else if ( ! error && ! data.delivery_date ) {
                error = sprintf(
                    __(
                        'Please make sure you have selected the Delivery date for %s.',
                        'dokan'
                    ),
                    data.store_name
                );
            } else if ( ! error && ! data.delivery_time_slot ) {
                error = sprintf(
                    __(
                        'Please make sure you have selected the delivery time slot for %s.',
                        'dokan'
                    ),
                    data.store_name
                );
            } else if (
                ! error &&
                'pickup' === data.selected_delivery_type &&
                ! data.store_pickup_location
            ) {
                error = sprintf(
                    __(
                        'Please make sure you have selected the store pickup location for %s.',
                        'dokan'
                    ),
                    data.store_name
                );
            }
        } );

        return error;
    };

    const getDeliveryValues = ( vendorId ) => {
        return deliveryTime[ vendorId ];
    };

    useEffect( () => {
        const datas = {};
        Object.keys( infos ).forEach( ( id ) => {
            let delivery = '';
            if ( infos[ id ].is_store_location_active ) {
                delivery = 'pickup';
            }
            if ( infos[ id ].is_delivery_time_active ) {
                delivery = 'delivery';
            }

            datas[ id ] = {
                ...defaultData,
                selected_delivery_type: delivery,
                store_name: infos[ id ].store_name,
                vendor_id: id,
            };
        } );

        setDeliveryTime( datas );

        if ( ! Object.values( deliveryTime ).length ) {
            props.onChange( {
                data: datas,
                error: __( 'Please select your delivery time.', 'dokan' ),
            } );
        }
    }, [] );

    const Body = () => {
        if (
            typeof settings?.vendorInfo === 'undefined' ||
            typeof settings?.vendorInfo !== 'object'
        ) {
            return;
        }

        return (
            <div className="delivery-time-body">
                <Spinner isLoading={ loading } />
                { Object.keys( infos ).map( ( item ) => {
                    return (
                        <DeliveryTimeItem
                            key={ item }
                            vendorId={ item }
                            info={ infos[ item ] }
                            onChange={ ( data ) =>
                                deliveryTimeHandler( item, data )
                            }
                            values={ getDeliveryValues( item ) }
                            setLoading={ setLoading }
                        />
                    );
                } ) }
            </div>
        );
    };

    const DeliveryTimeHtml = () => {
        if ( ! settings?.delivery_time_enabled ) {
            return <></>;
        }

        return (
            <div id="dokan-delivery-time-box">
                { props.error && <Error message={ props.error } /> }

                <Header time={ dateTime } />
                <Body />
            </div>
        );
    };

    return <DeliveryTimeHtml />;
};

export default DeliveryTime;
